import styles from './Footer.module.css';

function Footer() {
    return (
        <footer className={styles.footer}>
            <h2>Developed by Kayo Ennrique.</h2>
        </footer>
    )
}

export default Footer;